import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {TenNeighborhood, TenNeighborhoodSearchParams} from "../../_models/neighborhood.models";
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';

export const CheckState = createAction(
    '[Neighborhoods] Check State',
    props<{ payload: { items: TenNeighborhood[] } }>()
);

export const CheckStateSuccess = createAction(
    '[Neighborhoods] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: TenNeighborhood[] } }>()
);

export const LoadList = createAction(
    '[Neighborhoods] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Neighborhoods] Load List Success',
    props<{ payload: { items: TenNeighborhood[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Neighborhoods] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Neighborhoods] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[Neighborhoods] Set Filter',
    props<{ payload: TenNeighborhoodSearchParams }>()
);

export const SetLoading = createAction(
    '[Neighborhoods] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Neighborhoods] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const SetInitialState = createAction(
    '[Neighborhoods] Set Initial State'
);
